function getScenarioName (scenario) {
    return scenario['fips']+'('+scenario['modelname']+')'
}

export {getScenarioName};